export const UploadLimit = 20 * 1000 * 1000;
